import * as React from 'react';
import { useTranslation } from 'react-i18next';

// 🎯 Single Responsibility Principle (SRP)
// Este componente SOLO maneja el estado vacío de la tabla

interface EmptyStateProps {
  message: string;
  height?: string;
  className?: string;
  icon?: React.ReactNode;
  actionButton?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  message,
  height = '400px',
  className = '',
  icon,
  actionButton
}) => {
  // 🎯 Hook de traducción para namespace UI compartido
  const { t } = useTranslation('ui');

  return (
    <div
      className={`w-full border rounded-[10px] overflow-hidden flex items-center justify-center ${className} max-w-[100%]`}
      style={{ height }}
    >
      <div className="text-center text-gray-500 py-8 px-4 max-w-sm">
        {/* 🎯 Icono opcional para mejor UX */}
        {icon && (
          <div className="mb-4 flex justify-center text-gray-400">
            {icon}
          </div>
        )}

        {/* 🎯 Mensaje principal */}
        <p className="text-sm font-medium text-gray-600 mb-2">
          {message}
        </p>

        {/* 🎯 Texto secundario */}
        <p className="text-xs text-gray-500 mb-4">
          {t('virtualTable.noDataFound')}
        </p>

        {/* 🎯 Acción opcional (ej: botón "Agregar", "Refrescar") */}
        {actionButton && (
          <div className="mt-4">
            {actionButton}
          </div>
        )}
      </div>
    </div>
  );
}; 